module.exports = ".navbar {\n  padding: 0px !important; }\n\n.optional {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.component.scss
// module id = ./client/app/app.component.scss
// module chunks = main